module.exports = __webpack_public_path__ + "img/logo-icone.edc4e152.svg";